export const environment = {
production: false,
  BASE_URL:'https://ngkntk-api.tgconsulting.online/ngk-api',
  baseFacebookUrl: 'https://www.facebook.com',
  baseGraphUrl: 'https://graph.facebook.com',
  baseYouTubeUrl: 'https://www.youtube.com',
  baseGoogleApiUrl: 'https://www.googleapis.com/youtube/v3',
  baseSiteKey: '6LcC208eAAAAAHYPBxHqqtXdy5Afj0r8VPcIRZh4',
  sectionsPerPage: 5,
  questionsPerPage: 10,
  youTubeChannel: 'UCc5sf_7TrljlHqwbqYdCEww', // Id del canal de YouTube
  // Api Key para usar los servicios de YouTube
  // El Api Key esta restringido por direcciones HTTP si se cambia de dominio agregar el sitio a las recciones del panel de Google
  // https://console.cloud.google.com/apis/credentials/key/e84134b7-fb43-4e71-b402-68ff67fdf204?authuser=2&hl=es-419&project=ngkntkmexico
  //youTubeApiKey: 'se actualiza en la base de datos de mongodb',
  // El token se crea desde https://developers.facebook.com/tools/explorer/
  // El token tiene un tiempo de vida hay que estar monitoreando
  //accessTokenFB: 'se actualiza en la base de datos de mongodb',
  // ID de la pagina de FB
  idPageFB: '229150973827860',
  userNameFacebook: 'NGKNTKMexico', // Nombre de usuario de la Pagina para poder redireccionar a la pagina
  delayTimeForPartNumberAndCross: 2000, // Tiempo en milisegundos
  application:
  {
    name: 'angular-starter',
    angular: 'Angular 12.2.7',
    bootstrap: 'Bootstrap 5.1.1',
    fontawesome: 'Font Awesome 5.15.4',
  },
    langinit: 'spanish'
};
